import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import {REACT_APP_API_URL} from "../../config.js";
import {Col, Modal, Row} from "react-bootstrap";
import {word} from "../../word.js";
import Loader from "../BlueButton/Loader.js";
import Button from "../Button/Button.js";
import {TextField} from "@mui/material";
import Select from "react-select";
import {accountantRequest, taskManagerRequest} from "../../store/actions/task.js";
import Api from "../../Api.js";
import SuccessToast from "../BlueButton/SuccessToast.js";
import ErrorToast from "../BlueButton/ErrorToast.js";

function AddNotification({onHide, show}) {
    const dispatch = useDispatch()
    const account = useSelector((state) => state.task.accountant);
    const managers = useSelector((state) => state.task.managers);

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [imagePreviewUrl, setImagePreviewUrl] = useState('');
    const [images, setImages] = useState([]);
    const [option, setOption] = useState([]);
    const [date, setDate] = useState(new Date());
    const [accountantsClient, setAccountantsClient] = useState([]);
    const [managersClient, setManagersClient] = useState([]);
    const [disabled, setDisabled] = useState(false);
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const employee = useSelector((state) => state.manager.employee);
    const handleDateChange = (e) => {
        setDate(e.target.value);
    };

    const handleKeyPress = async (e) => {
        if (e.key === 'Enter') {
            await handleNewNotification();
        }
    };

    const handleNewNotification = async () => {
        const formData = new FormData();
        const formattedDate = moment(date).format('YYYY-MM-DD HH:mm:ss');

        accountantsClient.forEach((element) => {
            formData.append('accountants_client', `${REACT_APP_API_URL}accountant/${element.value}/`);
        });

        managersClient.forEach((element) => {
            formData.append('managers_client', `${REACT_APP_API_URL}manager/${element.value}/`);
        });

        images.forEach((img, i) => {
            formData.append(`file${i + 1}`, img, img.name);
        });

        formData.append('title', title);
        formData.append('description', description);
        formData.append('manager', employee.url);
        formData.append('date', formattedDate);

        setDisabled(true);
        setLoading(true);
        setSubmitted(true);

        if (title.length > 0 && (accountantsClient.length > 0 || managersClient.length > 0)) {
            try {
                await Api.createNotification(formData)
                setDisabled(false);
                setLoading(false);
                SuccessToast()
            } catch (e) {
                setDisabled(false);
                setLoading(false);
                ErrorToast()
            }

            await onHide()
        } else {
            setDisabled(false);
            setLoading(false);
        }
    };
    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImages((prev) => [...prev, file]);
            };
            reader.readAsDataURL(file);
        }
    };

    const removeImage = (index) => {
        setImages((prev) => {
            const newList = [...prev];
            newList.splice(index, 1);
            return newList;
        });
    };
    return (
        <Modal
            {...{onHide, show}}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header className='green-top'>
                <Modal.Title id="contained-modal-title-vcenter"
                             className="w-100 d-flex flex-row justify-content-between">
                    <span>Ծանուցում</span>
                    <div className="tool-tip-cont">
                        <div className="tool-tip">Փակել</div>
                        <i className="fas fa-times" onClick={onHide}/>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="container">
                    <Row className="d-flex justify-content-around">
                        <Col xs={12} sm={10}>
                            {/* Title Input */}
                            <div
                                className={title.length === 0 && submitted ? "input-validation input-validation-valid" : "input-validation"}>
                                <TextField
                                    error={title.length === 0 && submitted}
                                    variant="outlined"
                                    multiline
                                    label="Վերնագիր"
                                    name="title"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    onKeyDown={handleKeyPress}
                                />
                                {title.length === 0 && submitted &&
                                <div className="validation valid-center">Մուտքագրել տվյալներ</div>}
                            </div>

                            {/* Description Input */}
                            <div
                                className={description.length === 0 && submitted ? "input-validation input-validation-valid" : "input-validation"}>
                                <TextField
                                    error={description.length === 0 && submitted}
                                    variant="outlined"
                                    multiline
                                    label="Բովանդակություն"
                                    name="description"
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    onKeyDown={handleKeyPress}
                                />
                                {description.length === 0 && submitted &&
                                <div className="validation valid-center">Մուտքագրել տվյալներ</div>}
                            </div>

                            {/* Select Employees */}
                            <div
                                className={(accountantsClient.length === 0 && managersClient.length === 0 && submitted) ? "input-validation input-validation-valid" : "input-validation"}>
                                {option && (
                                    <Select
                                        closeMenuOnSelect={false}
                                        options={account.map(s => ({value: s.id, label: s.user.first_name + ' ' + s.user.last_name}))}
                                        className={accountantsClient.length === 0 && managersClient.length === 0 && submitted ? "error-select" : ""}
                                        onChange={(list) => setAccountantsClient(list || [])}
                                        placeholder="Ընտրել աշխատակից"
                                        isMulti
                                    />
                                )}
                                {accountantsClient.length === 0 && managersClient.length === 0 && submitted && (
                                    <div className="validation valid-center">Ընտրել տվյալներ</div>
                                )}
                            </div>

                            {/* Select Managers */}
                            <div
                                className={(accountantsClient.length === 0 && managersClient.length === 0 && submitted) ? "input-validation input-validation-valid" : "input-validation"}>
                                {managers && (
                                    <Select
                                        closeMenuOnSelect={false}
                                        options={managers.map(s => ({value: s.id, label: s.user.first_name + ' ' + s.user.last_name}))}
                                        className={accountantsClient.length === 0 && managersClient.length === 0 && submitted ? "error-select" : ""}
                                        onChange={(list) => setManagersClient(list || [])}
                                        placeholder="Ընտրել մենեջեր"
                                        isMulti
                                    />
                                )}
                                {accountantsClient.length === 0 && managersClient.length === 0 && submitted && (
                                    <div className="validation valid-center">Ընտրել տվյալներ</div>
                                )}
                            </div>

                            {/* Date Picker */}
                            <div className="input-validation">
                                <TextField
                                    id="datetime-local"
                                    label="Վերջնաժամկետ"
                                    type="datetime-local"
                                    onChange={handleDateChange}
                                    variant="outlined"
                                    InputProps={{inputProps: {min: moment(new Date()).format("YYYY-MM-DDTHH:mm")}}}
                                    sx={{width: 250}}
                                    InputLabelProps={{shrink: true}}
                                />
                            </div>

                            {/* Image Upload */}
                            <div className="img-icon-cont">
                                <div className="img-cont">
                                    {images.map((item, index) => (
                                        index < 4 ? (
                                            <div className="img-delete" key={index}>
                                                <div className="img">
                                                    <span
                                                        className={item.type === "image/jpeg" || item.type === "image/png" ? "icon-Photos" : "icon-files-empty"}/>
                                                    <span className="images-name">{item.name}</span>
                                                </div>
                                                <i className="far fa-times-circle" onClick={() => removeImage(index)}/>
                                            </div>
                                        ) : "..."
                                    ))}
                                </div>
                                <label>
                                    <span className="icon-Attachment"/>
                                    <input type="file" className="input-icon" onChange={handleImageUpload}/>
                                </label>
                            </div>

                            <div className="line-blue"/>

                            {loading && (
                                <div className="disable-loader">
                                    <Loader size={30}/>
                                </div>
                            )}

                            <Button
                                disabled={disabled}
                                buttonStyle="blue-button"
                                onChangeValue={handleNewNotification}
                                title={word.save}
                            />
                        </Col>
                    </Row>
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default AddNotification;